import { useApiClient } from '~/api-client';
import { useMutation } from '@tanstack/react-query';
import { DexLojackFormBootstrapView, LojackInquiry } from '@mark43/cad-api';
import { useForm } from 'react-hook-form';
import { DexForm } from './dex-form';
import { DexFormModel } from '../types';
import { DexQueriessubmitResource, DexQuerySubmissionLojackInquiry } from '@mark43/dex-api';
import { useIsLinkToAssignedEventCheckboxVisible } from './use-is-link-to-assigned-even-visible';
import { useBuildDexQuerySubmission } from './use-build-dex-query-submission';
import { useResetValuesAfterOriAliasChange } from './use-reset-values-after-ori-alias-change';

export function DexLojackForm({
    formBootstrapView,
}: {
    formBootstrapView: DexLojackFormBootstrapView;
}): React.ReactElement {
    const apiClient = useApiClient();
    const isLinkToAssignedEventCheckboxVisible = useIsLinkToAssignedEventCheckboxVisible();
    const defaultValues = {
        params: formBootstrapView.defaultValues,
        requestingUnitOption: null,
        agencyEventOption: null,
        ...(isLinkToAssignedEventCheckboxVisible ? { linkToAssignedEvent: true } : null),
    };
    const form = useForm<DexFormModel<LojackInquiry>>({
        mode: 'onBlur',
        defaultValues,
    });

    useResetValuesAfterOriAliasChange({
        formInitalValues: formBootstrapView.defaultValues,
        form,
        defaultValues,
    });

    const buildDexQuerySubmission = useBuildDexQuerySubmission(
        form,
        formBootstrapView.dexFormView.dexQuery
    );
    const sendQueryMutation = useMutation((formModel: DexFormModel<LojackInquiry>) => {
        return apiClient.request<DexQueriessubmitResource.SubmitLojackQuery>({
            service: 'DEX',
            method: 'POST',
            url: 'dex_queries/submit/lojack_inquiry',
            data: buildDexQuerySubmission(formModel) as DexQuerySubmissionLojackInquiry,
        });
    });
    return (
        <DexForm
            dexFormView={formBootstrapView.dexFormView}
            defaultParams={formBootstrapView.defaultValues}
            form={form}
            sendQueryMutation={sendQueryMutation}
        />
    );
}
